import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import { Menu, MenuItem } from '@sm/wds-react';
import { IconMenu, IconLogoGoldie } from '@sm/wds-icons';
import { defineMessages, T } from '@sm/intl';

const COPY = defineMessages({
  NAV_MY_ACCOUNT: {
    id: 'AppsDirectory.AppDirNavHeaderMobile.MyAccountLink',
    defaultMessage: 'My Account',
    description: '[Type: Link][Vis.: Low] - A link that will direct the user to their profile page',
  },
  NAV_SWITCH_ACCOUNTS: {
    id: 'AppsDirectory.AppDirNavHeaderMobile.SwitchAccountsLink',
    defaultMessage: 'Switch accounts',
    description: '[Type: Label][Vis.: high] - A link that will direct the user to the switch accounts page',
  },
  NAV_HELP_CENTER: {
    id: 'AppsDirectory.AppDirNavHeaderMobile.HelpCenterLink',
    defaultMessage: 'Help Center',
    description: '[Type: Link][Vis.: Low] - A link that will direct the user to the help center page',
  },
  NAV_SIGN_OUT: {
    id: 'AppsDirectory.AppDirNavHeaderMobile.SignOutLink',
    defaultMessage: 'Sign Out',
    description: '[Type: Link][Vis.: Low] - A link that will sign the user out',
  },
  NAV_SIGN_IN: {
    id: 'AppsDirectory.AppDirNavHeaderMobile.SignInLink',
    defaultMessage: 'Sign In',
    description: '[Type: Link][Vis.: Low] - A link that will direct the user to the sign in page',
  },
  NAV_SIGN_UP: {
    id: 'AppsDirectory.AppDirNavHeaderMobile.SignUpLink',
    defaultMessage: 'Sign Up',
    description: '[Type: Link][Vis.: Low] - A link that will direct the user to the sign up page',
  },
});

function urlWithSearch(url, search) {
  return `${url}${search}`;
}

const AppDirNavHeaderMobile = ({ navItems, location: { search } }) => {
  const authorizedMenuItems = navItems.map(nav => (
    // The query params need to be preserved between urls (needed for ut_source)
    <MenuItem isNavigable navigationTarget={urlWithSearch(nav.target, search)} key={nav.target}>
      {nav.text}
    </MenuItem>
  ));
  return (
    <div className="sm-app-dir-nav-header wds-p-t-3 wds-p-b-3 wds-flex wds-flex--y-center wds-flex--between">
      <span className="wds-type wds-type--light wds-type--section-title">
        <IconLogoGoldie size="xl" />
      </span>

      <div>
        <Menu
          autoClose
          noRules
          dense
          placement="bottom-right"
          menuTrigger={
            <div
              className="sm-app-dir-nav-header__nav-user-trigger sm-app-dir-nav-header__nav-user-trigger--mobile"
              data-testid="AppDirNavHeaderMobile__UnauthenticatedUserMenuTrigger"
            >
              <span className="wds-type wds-type--section-title wds-type--light">
                <IconMenu size="lg" />
              </span>
            </div>
          }
        >
          {authorizedMenuItems}
          <MenuItem isNavigable navigationTarget={urlWithSearch('/user/sign-in', search)}>
            <T desc={COPY.NAV_SIGN_IN} />
          </MenuItem>
          <MenuItem isNavigable navigationTarget={urlWithSearch('/user/sign-up', search)}>
            <T desc={COPY.NAV_SIGN_UP} />
          </MenuItem>
        </Menu>
      </div>
    </div>
  );
};

AppDirNavHeaderMobile.propTypes = {
  navItems: PropTypes.arrayOf(
    PropTypes.shape({
      target: PropTypes.string.isRequired,
      text: PropTypes.node.isRequired,
      requiresAuthentication: PropTypes.bool,
    })
  ).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
    search: PropTypes.string,
  }).isRequired,
};

export default withRouter(AppDirNavHeaderMobile);
